export default __webpack_public_path__ + "static/media/designResearchLogo.9a464518.svg";